import { stripHtml } from "../../utils/richText";
export default function CategoryFilter({ categories, value, onChange }) {
  return (
    <label className="block">
      <span className="sr-only">Filter by category</span>
      <select value={value} onChange={(event) => onChange(event.target.value)} className="w-full rounded-xl border border-line bg-white px-4 py-3 text-sm font-bold text-dark shadow-sm transition focus:border-primary focus:ring-2 focus:ring-emerald-100">
        <option value="all">All Categories</option>
        {categories.map((category) => (
          <option key={category.id} value={category.id}>{stripHtml(category.name)}</option>
        ))}
      </select>
    </label>
  );
}
